import { useState } from "react";
import CardWrapper from "./components/CardWrapper";
import Start from "./components/Start";
import { Routes, Route } from "react-router-dom";

import "./style.scss";

function App() {
  const [players, setPlayers] = useState({ first: "", second: "" });

  return (
    <div className="wrapper">
      <Routes>
        <Route
          path="/"
          element={
            <Start
              startGame={startGame}
              players={players}
              playerFunction={playerFunction}
            />
          }
        />
        <Route path="gameStart" element={<CardWrapper players={players} />} />
      </Routes>
    </div>
  );

  function startGame(e) {
    if (players.first !== "" && players.second !== "") {
      console.log("Game Starts");
    } else {
      alert("Enter the players name");
      e.preventDefault();
    }
  }

  function playerFunction(e) {
    const target = e.target.getAttribute("name");
    setPlayers((pre) => ({ ...pre, [target]: e.target.value }));
  }
}

export default App;
